goog.provide("shadow.js.shim.module$src$svg$type$file_type$json_svg$default");
shadow.js.shim.module$src$svg$type$file_type$json_svg$default = shadow.js.shim.module$src$svg$type$file_type$json_svg.default;
